import { lazyGetLinkProviderType } from 'owa-fileprovider-link';
import {
    lazyEvaluateSafeLink,
    lazyIsSafeLink,
    ORIGINALSRC_ATTTIBUTE_NAME,
} from 'owa-safelinks-evaluator';
import { isSupportedProviderType } from './isSupportedProviderType';

export async function tryRemoveSafeLinkWrap(
    link: HTMLAnchorElement,
    skipUnsupportedLinks: boolean
): Promise<string> {
    const isSafeLink = await lazyIsSafeLink.import();
    if (await isSafeLink(link)) {
        if (skipUnsupportedLinks) {
            // use originalSrc to filter out unsupported link as unwrap is an expensive server call
            const url: string = link.getAttribute(ORIGINALSRC_ATTTIBUTE_NAME);
            const getLinkProviderType = await lazyGetLinkProviderType.import();
            const fileProviderType = await getLinkProviderType(url);
            if (!isSupportedProviderType(fileProviderType)) {
                return null;
            }
        }

        const evaluateSafeLink = await lazyEvaluateSafeLink.import();
        const originalSrc: string = await evaluateSafeLink(link.href);
        if (originalSrc?.length > 0) {
            return originalSrc;
        }
    }
    return link.href;
}
